export default __webpack_public_path__ + "static/media/success-tick.cbb477af.png";